import { Component, Input, SimpleChanges } from '@angular/core';
import { ReportResidentialPrimeConstants } from './report-residential-prime.constants';
import { SharedService } from 'src/app/common/services/shared.service';
import { ResidentialPrimeMenuEnum } from './report-residential-prime.enum';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { ReportResidentialPrimeService } from './report-residential-prime.service';
import { Subject, takeUntil } from 'rxjs';
import moment from 'moment';
import { UnitTypeEnum } from '../../models/unit-type-enum';
import { GlobalContants } from 'src/app/common/constants/global.contants';

@Component({
  selector: 'app-report-residential-prime',
  templateUrl: './report-residential-prime.component.html',
  styleUrls: ['./report-residential-prime.component.scss']
})
export class ReportResidentialPrimeComponent {
  @Input() params: string = '';
  overViewMenu: any = ReportResidentialPrimeConstants.overViewMenu;
  officeInventoryMenuEnum = ResidentialPrimeMenuEnum;
  chartView = ReportsChartEnum;
  UnitTypeEnum = UnitTypeEnum;
  destroy$ = new Subject<void>();
  currentScroll: any = '';
  langName: any;
  CurrencyCode: string = '';
  overviewData: any = {};
  overviewLoading = false;
  isFirstTime = true;

  transactionLoading: boolean = false;
  transactionColumns = ReportResidentialPrimeConstants.transactionColumns;
  tableDropdown = ReportResidentialPrimeConstants.tableDropdown;
  transactionCount: number = 0;

  rentalCount: number = 0;
  rentalLoading: boolean = false;
  rentalColumns = ReportResidentialPrimeConstants.rentalColumns

  landLoading: boolean = false;
  landColumns = ReportResidentialPrimeConstants.landColumns;
  landCount: number = 0;

  projectLoading: boolean = false;
  projectColumns = ReportResidentialPrimeConstants.projectColumns;
  projectCount: number = 0;
  constructor(
    public sharedService: SharedService,
    private residentialService: ReportResidentialPrimeService
  ) {
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
      if (lang && !this.isFirstTime) {
        this.getReports();
      }
    })
    //Update Column Monthly/Annual Properties Table
    if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      const columnsToUpdate = [
        { header: 'rentalPerMonth', columnName: 'reports.rentalPerAnnum' }
      ];
      //Residential Units - Grade wise Table
      columnsToUpdate.forEach(column => {
        const targetColumn = this.rentalColumns.find(x => x.header === column.header);
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
      });
    }
  }
  ngOnInit() {
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.getReports();
    this.isFirstTime = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      this.getReports();
    }
  }
  /**
     * All Rports api call
    */
  getReports() {
    this.getOverview();
  }

  /**
     * Overview all type Data
     */
  getOverview() {
    console.log('test');

    this.overviewLoading = true;
    this.residentialService.getOverview()
      .pipe(takeUntil(this.destroy$)) // Unsubscribe when destroy$ emits
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              this.overviewData = res.data;
              this.overviewData['untillDate'] = this.overviewData.as_of_date ? moment.utc(this.overviewData.as_of_date).local().format('DD MMM YYYY') : null;
            }
            this.overviewLoading = false;
          },
          error: (error: any) => {
            this.overviewLoading = false;
          }
        }
      )
  }

  /**
   *
   * @param menu
   * if click menu scroll particular div
   */
  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }
  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
